module.exports = __webpack_public_path__ + "da887f50154996f58a55769dd9d2fa21.msgpack";


/*****************
 ** WEBPACK FOOTER
 ** ./~/file-loader!./src/game/models/chick.msgpack
 ** module id = 591
 ** module chunks = 0
 **/